/* TIDALOVE CUSTOM: reliable product gallery navigation */
(() => {
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('tidalove-theme-editor');
  }

  function init() {
    // Keep custom arrows disabled in the editor while checking the native gallery.
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }
    if (window.innerWidth < 1025) return;
    document.querySelectorAll('.template-product .product-default .productView[data-product-handle]').forEach(view => {
      const slider = view.querySelector('[data-image-gallery-main]');
      const wrapper = view.querySelector('.productView-image-wrapper');
      const existingCursor = view.querySelector('.cursor-wrapper');
      if (!slider || !wrapper || !existingCursor || wrapper.querySelector('.tidalove-gallery-hitareas')) return;
      if (slider.querySelectorAll('.productView-image').length < 2) return;
      const nav = document.createElement('div');
      nav.className = 'tidalove-gallery-hitareas';
      for (const direction of ['prev', 'next']) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tidalove-gallery-hitarea tidalove-gallery-hitarea--' + direction;
        button.setAttribute('aria-label', direction === 'prev' ? 'Previous product image' : 'Next product image');
        button.innerHTML = '<span aria-hidden="true"><svg viewBox="0 0 88 48" width="72" height="40" fill="none" aria-hidden="true"><g transform="' + (direction === 'prev' ? 'translate(88 0) scale(-1 1)' : '') + '"><path d="M33 24H56" stroke="#0D3B66" stroke-width="4.5" stroke-linecap="round"/><path d="M44 12Q50 19 56 24Q50 29 44 36" stroke="#0D3B66" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M58 14Q65 21 70 24Q65 27 58 34" stroke="#597995" stroke-width="2.4" stroke-linecap="round"/><path d="M64 17Q69 22 73 24Q69 26 64 31" stroke="#597995" stroke-width="1.8" stroke-linecap="round"/></g></svg></span>';
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (!window.jQuery) return;
          const $slider = window.jQuery(slider);
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick(direction === 'prev' ? 'slickPrev' : 'slickNext');
          }
        });
        nav.appendChild(button);
      }
      wrapper.appendChild(nav);
      wrapper.classList.add('tidalove-gallery-navigation-ready');
      const sync = () => {
        nav.style.top = slider.offsetTop + 'px';
        nav.style.height = slider.offsetHeight + 'px';
      };
      if (window.jQuery) {
        window.jQuery(slider).on('afterChange.tidaloveGallery reInit.tidaloveGallery', sync);
      }
      sync();
      if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(sync);
        resizeObserver.observe(slider);
      }
      window.addEventListener('resize', sync, { passive: true });
      document.addEventListener('shopify:section:select', sync);
      document.addEventListener('shopify:block:select', sync);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
